import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { environment } from '../../../environments/environment';

declare global {
	interface Window {
		Tawk_API?: any;
		Tawk_LoadStart?: Date;
	}
}

@Injectable({ providedIn: 'root' })

export class ChatService {
	constructor(private api: ApiService) {
		window.Tawk_API = window.Tawk_API || {};
	}
	private isLoaded : boolean = false;
	private isVisible : boolean = true;
	private timeoutId?: ReturnType<typeof setTimeout>;
	private scriptUrl : string = environment.TAWK_TO_KEY;

	setUser(userId: string, username: string, data: any,  hash : string) : void {
		const checkReady = setInterval(() => {
			if (window?.Tawk_API && window?.Tawk_API?.setAttributes) {
				window.Tawk_API.setAttributes({ name: username, userId, client: data?.client, firstName: data?.firstName, lastName: data?.lastName, hash },
					(error: any) => {
						if (error) {
							console.error('Tawk.to error:', error);
						}
					}
				);
				clearInterval(checkReady);
			}
		}, 500);
	}

	async getChatValidationKey(email: string): Promise<string> {
		const hash = (await this.api.get(`/chat/chatHashKey?email=${email}`) as any);
		  return hash.key;
	}

	load(): void {
		if (!this.isVisible) window.Tawk_API.showWidget();
		if (this.isLoaded) return;

		window.Tawk_API = window?.Tawk_API || {};
		window.Tawk_LoadStart = new Date();

		const s1 = document.createElement('script');
		s1.async = true;
		s1.src = this.scriptUrl;
		s1.charset = 'UTF-8';
		s1.setAttribute('crossorigin', '*');

		s1.onload = () => {
			this.isLoaded = true;
			console.log('Tawk.to loaded');
		};

		const s0 = document.getElementsByTagName('script')[0];
		if (s0 && s0.parentNode) {
			s0.parentNode.insertBefore(s1, s0);
		}

		window.Tawk_API.onChatMinimized = () => this.closeChat();
		window.Tawk_API.onChatMaximized = () => this.openChat();

	}

	closeChat() : void {
		this.timeoutId = setTimeout(() => {
			window.Tawk_API.hideWidget();
			this.isVisible = false
		}, 60000);

	}

	openChat() : void {
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
			this.timeoutId = undefined;
		}
	}
}
